
import React from 'react';
// import ReactLogo from "../assets/img/logo.png";
import ReactLogo from "../assets/img/tlogo.png";
import { Image } from '@themesberg/react-bootstrap';

export const Preloader = (props) => {

  const { show } = props;

  return (
    show && (
        <div className={`preloader bg-soft flex-column justify-content-center align-items-center ${show ? "" : "show"}`}>
            {/* <Image className="loader-element animate__animated animate__jackInTheBox" src={ReactLogo} height={40} /> */}
            <Image className="animate__animated animate__jackInTheBox" src={ReactLogo} height={40} />
        </div>
    )
  );
};
